<template>
	<div>
		<b-container fluid class="margin-top-header">
			<b-row>
				<b-col lg="8" offset-lg="2" > 
					<b-table-simple borderless class="bg-grey shadow-sm my-5">
						<b-tr>
							<b-td class="no-padding text-center"><span class="section-header">¡{{customer.name}}, Bienvenido!</span></b-td>
						</b-tr>
						<b-tr>
							<b-td class="no-padding">
								<span class="section-subheader display-2">Tu cuenta se ha creado con éxito, comienza con el universo de oportunidades en Macal! </span>
							</b-td>
						</b-tr>
					</b-table-simple>
				</b-col>
			</b-row>
			<b-row class="pb-5">
				<b-col offset-lg="2" lg="8" class="text-center" >
					<b-button size="lg" class="mt-3 pl-5 pr-5" variant="macal" to="/autos">Ahora sigue viendo autos en Macal</b-button>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
  export default {
    name: 'user-success',
    components: {},
	props: {
        customer:{
            rut: null,
            name: null,
            lastnameFather: null,
            lastnameMother: null,
            phone: null,
            email: null,
            region_id: null,
            commune_id: null,
            name_contact: null,
            phone_contact: null,
            reference: null
        }
    },
	data (){
		return{
			amount: "",
			due: 60,
			loading: false,
            color: "#E4610C",
			state: null,
		}
	},
	mounted() {

	},
	methods:{
	},
	watch: {
		price: {
			handler: function() {}
		}
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>